import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate():
    boolean | Observable<boolean> | Promise<boolean> {
      const isAuth = this.authService.getIsAuth();

      if (!isAuth) {
        this.router.navigate(['/login']);
      }
      return true;
  }
}
